import { getGlobalParamsOptionsAsync } from '@/utils/common'

export const searchFormConfig = {
  // colLayout: {
  //   span: 8
  // },
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: 'general.name'
    },
    {
      field: 'tableId',
      type: 'select',
      label: 'Template',
      isResolveGlobalParams: true,
      options: [],
      handler: () =>
        getGlobalParamsOptionsAsync('paramTemplate', {
          isNeedPreFix: false
        })
    },
    {
      field: 'groupId',
      type: 'select',
      label: 'Template Group',
      isResolveGlobalParams: true,
      options: [],
      handler: () =>
        getGlobalParamsOptionsAsync('terminalParamGroup', {
          isNeedPreFix: false
        })
    },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
